import Popover from "common/Popover/Popover";
import Title from "common/Typography/Title";
import { FilterSectionData } from "@shared/features/filters/types";
import SliderFiltersSection from "common/Filters/SliderFiltersSection";
import {
  getAllSelectedDisplay,
  getSliderValueDisplay,
} from "@shared/features/filters/utils";
import { FilterType, SliderFilterType } from "@shared/types";
import { MobileResetButton, StyledInput } from "common/Filters/common/styles";
import { useBottomNavigator } from "utils/hooks/misc";
import React from "react";
import BottomDrawer from "common/Drawers/BottomDrawer";

const SliderFiltersChips = ({
  title,
  value,
  options,
  filterType,
  isSingleRowView,
  onChange,
  resetButtonData,
  ...props
}: FilterSectionData<SliderFilterType>) => {
  const bottomNavigatorData = useBottomNavigator();
  const isBottomNavigator = bottomNavigatorData.baseShouldDisplay;
  const allSelected = options[0] === value[0] && options[1] === value[1];

  const content = (
    <div style={{ width: isBottomNavigator ? "100%" : 300 }}>
      {!isBottomNavigator && <Title level={4}>{title}</Title>}
      <SliderFiltersSection
        title={title}
        value={value}
        options={options}
        filterType={filterType}
        onChange={onChange}
        resetButtonData={resetButtonData}
        {...props}
      />
      {isBottomNavigator && (
        <MobileResetButton
          onClick={resetButtonData.onClick}
          style={{ marginTop: 24 }}
          disabled={allSelected}
        >
          {resetButtonData.resetText}
        </MobileResetButton>
      )}
    </div>
  );

  const placeholder = getAllSelectedDisplay(
    title,
    isSingleRowView,
    filterType !== FilterType.CONSECUTIVE_ACTIVE_DAYS
  );

  let inputValue: string | undefined;
  if (!allSelected && options.length) {
    inputValue = getSliderValueDisplay(filterType, value, options);
  }

  const width = filterType === FilterType.LEVERAGE ? 110 : 140;

  const input = (
    <StyledInput
      value={inputValue}
      placeholder={placeholder}
      allowClear={!isBottomNavigator}
      readOnly={true}
      style={isSingleRowView ? { width } : undefined}
      $showClear={!!inputValue}
      $isSingleRowView={isSingleRowView}
      $hasValue={!!inputValue}
      onChange={(value) => {
        if (!value.target.value) {
          onChange(options);
        }
      }}
    />
  );

  if (isBottomNavigator) {
    return (
      <BottomDrawer title={title} triggerElement={input} content={content} />
    );
  }

  return (
    <Popover content={content} trigger={["click"]} placement="bottom">
      {input}
    </Popover>
  );
};

export default SliderFiltersChips;
